import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { CreateModelMutation, Model } from '#/graphql/types';
import { createModel } from '#/graphql/mutations';
import { createMutationFields } from '../utils/mutationDataFields';
import { inUseStatuses } from '../utils/constants';

const q = gql(createModel);

const useModelCreate = () => {
  const [mutation, result] = useMutation<CreateModelMutation>(q);
  const createModel = useCallback(
    async (model: Model) => {
      const response = await mutation({
        variables: {
          data: {
            ...pick(model, createMutationFields),
            inUseStatus: model.inUseStatus ?? inUseStatuses.newlyCreated.key,
          },
        },
      });
      return get(response, 'data.createModel', undefined);
    },
    [mutation],
  );

  return { createModel, result };
};

export default useModelCreate;
